<template>
    <article class="media">
        <div class="media-left">
            <a @click="noteOpen=!noteOpen">
                <b-icon :icon="noteOpen?'minus-square':'plus-square'" size="is-medium" :type="noteHover?'is-primary':'is-spifi'"></b-icon>
            </a>
        </div>
        <div class="media-content">
            <transition name="fade" mode="out-in" appear v-on:after-enter="noteOpen?focusInput():null">
                <form v-if="noteOpen">
                    <ValidationObserver ref="observer" v-slot="{ passes }">
                        <ValidationProvider name="Note" rules="required" v-slot="{ errors, valid }">
                            <b-field :type="{'is-danger':errors[0], 'is-success': valid}" :message="errors[0]">
                                <b-input type="textarea" placeholder="Add a note..." maxlength="200"
                                    v-model="noteInput" ref="note">
                                </b-input>
                            </b-field>
                        </ValidationProvider>
                        <ValidationProvider name="Person" rules="required" v-slot="{ errors, valid }">
                            <b-field :type="{'is-danger':errors[0], 'is-success': valid}" :message="errors[0]">
                                <b-input type="input" placeholder="Your Name" icon="user" v-model="notePerson">
                                </b-input>
                            </b-field>
                        </ValidationProvider>
                        <b-button class="button" @click="passes(postNote)">Post note</b-button>
                    </ValidationObserver>
                </form>
                <div v-else><a @click="noteOpen=!noteOpen;noteHover=false;" @mouseenter="noteHover=true" @mouseleave="noteHover=false"><b-tag type="is-white" size="is-medium" class="is-note">Write a note…</b-tag></a></div>
            </transition>
        </div>
    </article>
</template>

<script>
import {
  extend
} from 'vee-validate';
import {
  required, email
} from 'vee-validate/dist/rules';

// Add the rules
extend('email', email);
extend('required', {
  ...required,
  message: 'Nicht vergessen…'
});

import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
export default {
    data() {
        return {
            noteHover: false,
            noteOpen: false,
            noteInput: "",
            notePerson: ""
        }
    },
    props: ['ID'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    computed: {
        nowDate() {
            let currentDate = new Date
            let dateString
            let year    = currentDate.getFullYear();
            let month   = currentDate.getMonth() + 1;
            let day     = currentDate.getDate();
            dateString = year + '.' + month + '.' + day
            return dateString
        },
        nowTime() {
            let currentDate = new Date
            let timeString
            let hour   = currentDate.getUTCHours() + 2
            let minutes = currentDate.getUTCMinutes()
            timeString = hour + ":" + minutes
            return timeString
        },
        userName() {
            return this.$store.getters.getUserName
        }
    },
    methods: {
        focusInput() {
            this.$refs.note.focus();
        },
        postNote() {
            let noteArray = [this.ID, this.nowDate, this.nowTime, this.noteInput, this.notePerson]
            // console.log(noteArray)
            // Post new note, with date, to TODO ID
            this.$store.dispatch("addNote", noteArray)
            this.$buefy.toast.open({
                message: "On " + this.nowDate + ", at " + this.nowTime + ", you posted: \"" + this.noteInput + "\"",
                type: 'is-success',
                position: 'is-bottom',
                duration: 6000
            })
            this.clear()
        },

        dateToString() {
            // This format is better for sorting
            // 2016.10.15
            let date = new Date
            let dateString
            let year    = date.getFullYear();
            let month   = date.getMonth() + 1;
            let day     = date.getDate();
            dateString = year + '.' + month + '.' + day
            return dateString
            // return this.date.toString()
        },

        close() {
            this.$emit('close')
        },
        clear() {
            this.noteInput = ""
            this.notePerson = ""
            this.noteOpen = true
        }
    },
    mounted() {
        this.notePerson = this.userName
    }
}
</script>

<style scoped>
.modal .animation-content .modal-card {
    margin-left: auto;
    margin-right: auto;
}
a:hover .has-text-spifi {
    color: #3BFFFC !important;
}
.is-note {
    cursor: text;
}
</style>